import { lazy } from 'react';
import PageTransition from '@/components/PageTransition';

const Landing = lazy(() => import('@/pages/active-page/landing/index'));

const withPageTransition = (Component: React.ComponentType) => (
  <PageTransition>
    <Component />
  </PageTransition>
);

// 活动页路由配置，因为是二级路由，所以path不需要以/开头
// 最终路由为/active-page/**，例如/active-page/landing
export default [
  {
    path: 'landing',
    element: withPageTransition(Landing),
  },
  
];
